const s = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Equals Icon</title><desc>A picture showing the equals sign.</desc><path d="M5 13.5h14v2H5zm0-5h14v2H5z"/></svg>';
export {
  s as default
};
